import React from "react";

export default function HowtoPage() {

  return (
      <div className="lo-page lo-prose">
        <div className="lo-page-header">
          <h1>How To Use Nzyme Connect</h1>
          <p>Setting up your Nzyme Connect integration is easy.</p>
        </div>

        <ol className="lo-steps">
          <li>Sign up for your Connect account and log in.</li>
          <li>Create a cluster in the Connect UI and copy the API key that was automatically generated for it.</li>
          <li>As super administrator, navigate to the <em>Connect</em> page in your Nzyme Web Interface and enter
            your API key.</li>
          <li>Your Nzyme infrastructure will automatically connect and exchange data.</li>
        </ol>
      </div>
  )

}
